'use client';

import { Skeleton, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useQuery } from '@tanstack/react-query';
import { ColumnCard } from '@ui';
import { secondsToMilliseconds } from 'date-fns';
import { useRouter, useSearchParams } from 'next/navigation';
import { Dispatch, SetStateAction } from 'react';
import { getCycles } from '../services/cycles';
import { useMixedPanel } from '../store/useMixPanel';
import { Title } from './heading';

const ActiveBasketsList = ({
  setShowGetStarted,
}: {
  setShowGetStarted: Dispatch<SetStateAction<boolean>>;
}) => {
  const { trackEvent } = useMixedPanel();
  const params = useSearchParams();
  const theme = useTheme();
  const { push } = useRouter();
  const { isPending, isError, data, error } = useQuery({
    queryKey: ['active-cycles'],
    queryFn: () => getCycles({ status: 'running', order_by: '-created' }),
    refetchInterval: (data) => {
      return data.state.error || data.state.data?.length === 0
        ? 0
        : Number(params.get('refetchInterval')) || secondsToMilliseconds(3);
    },
    refetchOnWindowFocus: true,
  });

  if (isPending) {
    return (
      <Stack gap={2}>
        <Skeleton animation={'wave'} variant="rectangular" height={48} />
        <Skeleton animation={'wave'} variant="rectangular" height={48} />
        <Skeleton animation={'wave'} variant="rectangular" height={48} />
      </Stack>
    );
  }

  if (data && data?.length === 0) {
    setShowGetStarted(true);
    return <></>;
  }

  return (
    <Stack gap={2}>
      <Title>Active Baskets</Title>
      <Stack gap={1}>
        {data?.map((x) => {
          return (
            <ColumnCard
              basketTitle={x.strategy === 'hunter_long' ? 'BUY' : 'SELL'}
              basketValue={x.currentValue}
              returnsPercentage={x.returns}
              key={x.id}
              onClick={() => {
                trackEvent('CLICK: Active basket');
                push(`/details/${x.id}`);
              }}
              theme={{
                buttonSx: {
                  color: theme?.palette?.common?.white,
                  backgroundColor: theme?.palette?.primary?.main,
                  '&:hover': {
                    backgroundColor: theme?.palette?.primary?.main,
                  },
                },
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default ActiveBasketsList;
